export const getExternalInvoiceOriginatorReference = (externalInvoiceId: string | null | undefined) =>
  externalInvoiceId ? `externalInvoice:${externalInvoiceId}` : undefined
